import React, { useState } from "react";
import useRedirect from "@helpers/use-redirect";

const PageActionContext = React.createContext({
    isNextBusy: false,
    setNextBusy: (value) => {},

    isPrevBusy: false,
    setPrevBusy: (value) => {},

    isNextDisabled: false,
    setNextDisabled: (value) => {},

    isPrevDisabled: false,
    setPrevDisabled: (value) => {},

    isNextClicked: false,
    setNextClicked: (value) => {},

    isPrevClicked: false,
    setPrevClicked: (value) => {},

    nextEventData: null,
    prevEventData: null,

    reset: () => {},

    navigate: (url, isExternal) => {},
    goNext: () => {},
    goBack: () => {},
});

export const PageActionContextProvider = (props) => {
    const [isNextBusy, setNextBusy] = useState(false);
    const [isPrevBusy, setPrevBusy] = useState(false);
    const [isNextDisabled, setNextDisabled] = useState(false);
    const [isPrevDisabled, setPrevDisabled] = useState(false);

    const [isNextClicked, setNextClicked] = useState(false);
    const [nextEventData, setNextEventData] = useState(null);

    const [isPrevClicked, setPrevClicked] = useState(false);
    const [prevEventData, setPrevEventData] = useState(null);

    const redirect = useRedirect();

    return (
        <PageActionContext.Provider
            value={{
                isNextBusy: isNextBusy,
                setNextBusy: setNextBusy,

                isPrevBusy: isPrevBusy,
                setPrevBusy: setPrevBusy,

                isNextDisabled: isNextDisabled,
                setNextDisabled: setNextDisabled,

                isPrevDisabled: isPrevDisabled,
                setPrevDisabled: setPrevDisabled,

                isPrevClicked: isPrevClicked,
                setPrevClicked: setPrevClicked,

                isNextClicked: isNextClicked,
                setNextClicked: setNextClicked,

                nextEventData: nextEventData,
                prevEventData: prevEventData,

                handleNextClick: ({ url, isExternal }) => {
                    setNextEventData({
                        url,
                        isExternal,
                    });
                    setNextClicked(true);
                },

                handlePrevClick: ({ url, isExternal }) => {
                    setPrevEventData({
                        url,
                        isExternal,
                    });
                    setPrevClicked(true);
                },

                reset: () => {
                    setNextBusy(false);
                    setPrevBusy(false);
                    setNextClicked(false);
                    setPrevClicked(false);
                },

                navigate: (url, isExternal) => {
                    if (url) {
                        redirect(url, isExternal);
                    }
                },

                goNext: () => {
                    const { url, isExternal } = nextEventData ?? {};
                    if (url) {
                        redirect(url, isExternal);
                    }
                },

                goBack: () => {
                    const { url, isExternal } = prevEventData ?? {};
                    if (url) {
                        redirect(url, isExternal);
                    }
                },
            }}
        >
            {props.children}
        </PageActionContext.Provider>
    );
};

export default PageActionContext;
